/* Barrier Product Gallery — custom elements.
   Touch devices scroll natively (smooth momentum + snap).
   Mouse users can drag the track.
   Tapping an image does NOT open the lightbox (disabled by design). */

if (!customElements.get('barrier-product-media')) {
  class BarrierProductMedia extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.barrier-pgallery__track');
      this.slides = Array.from(this.querySelectorAll('.barrier-pgallery__slide'));

      this._initDrag();
    }

    _initDrag() {
      if (!this.track) return;
      const track = this.track;
      let isDown = false;
      let startX = 0;
      let startScroll = 0;

      const onDown = (e) => {
        // Touch/pen: let the browser handle scrolling natively (momentum + snap).
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        try {
          track.setPointerCapture(e.pointerId);
        } catch (_) {}
      };

      const onMove = (e) => {
        if (!isDown) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      };

      const onUp = (e) => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        try {
          track.releasePointerCapture(e.pointerId);
        } catch (_) {}
        // Snap to nearest slide after a mouse drag
        if (this.slides.length) {
          const center = track.scrollLeft + track.clientWidth / 2;
          let closest = this.slides[0];
          let dist = Infinity;
          for (const s of this.slides) {
            const c = s.offsetLeft + s.offsetWidth / 2;
            const d = Math.abs(c - center);
            if (d < dist) {
              dist = d;
              closest = s;
            }
          }
          track.scrollTo({ left: closest.offsetLeft, behavior: 'smooth' });
        }
      };

      track.addEventListener('pointerdown', onDown);
      track.addEventListener('pointermove', onMove);
      track.addEventListener('pointerup', onUp);
      track.addEventListener('pointercancel', onUp);
      // Prevent native image drag interfering
      track.addEventListener('dragstart', (e) => e.preventDefault());
    }
  }
  customElements.define('barrier-product-media', BarrierProductMedia);
}

/* Lightbox element stays defined (it may exist in the DOM) but nothing opens it. */
if (!customElements.get('barrier-lightbox')) {
  class BarrierLightbox extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.barrier-lightbox__track');
      this.slides = Array.from(this.querySelectorAll('.barrier-lightbox__slide'));
      this.currentEl = this.querySelector('[data-current]');
      this.totalEl = this.querySelector('[data-total]');
      this.index = 0;

      this.querySelectorAll('[data-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
    }

    open(index) {
      this.hidden = false;
      document.body.classList.add('barrier-lightbox-open');
    }

    close() {
      this.hidden = true;
      document.body.classList.remove('barrier-lightbox-open');
    }
  }
  customElements.define('barrier-lightbox', BarrierLightbox);
}